<template>
  <div class="_InfoBox">
    <div class="_Info"
			v-loading="loading"
			element-loading-text="加载中..."
			element-loading-spinner="el-icon-loading"
			element-loading-background="rgba(255, 255, 255, 1)"
		>
			<template v-if="!loading">
				<!-- <div class="_gift">
					<img class="_bg" src="../../assets/_gift_2.png" alt="">
					<div class="_cot">
						<div class="_left">
							<span class="_giftText">领取每日<span class="_p1">免费彩虹币</span><i @click.stop="visibles()" class="_elIcon"></i></span>
							<div class="_popover" v-if="visible">
								<span class="_h1">规则如下：</span>
								<span>1. 用户必须实名认证才能领取</span>
								<span>2. 每日可领取，每日领取的彩虹币在当日24点清零</span>
								<span>3. 使用代理优先消费免费领取的彩虹币，当天领取的免费彩虹币消费完毕，再消费账户余额</span>
								<span>4. 每天客户可以领取20彩虹币</span>
								<span>5. 每天免费领取的彩虹币，只能用于短效套餐消费不能用于独享代理套餐</span>
							</div>
						</div>
						<div class="_right">
							<p :class="'_btn ' + [receiveType ? '_true' : '']" @click.stop="_receive()">{{receiveType ? '已领取' : '领取彩虹币'}}</p>
						</div>
					</div>
				</div> -->
				<div class="_top">
					<p class="_label">用户基本信息</p>
					<div class="_list">
						<p v-if="infoData">
							<span>手机号</span>
							<span>{{infoData.phone}}</span>
						</p>
						<p v-if="infoData && infoData.is_company == 1">
							<span>公司认证名称</span>
							<span>{{infoData.company_name}}</span>
						</p>
						<p v-if="infoData && infoData.is_company == 0">
							<span>认证姓名</span>
							<span>{{infoData.realname}}</span>
						</p>
						<!-- <p>
							<span>微信号</span>
							<span v-if="infoType" >{{wx}}</span>
							<el-input v-if="!infoType"  v-model="wx" placeholder="请输入内容"></el-input>
						</p>
						<p>
							<span>QQ</span>
							<span v-if="infoType">{{qq}}</span>
							<el-input v-if="!infoType" style="margin-top:3px" v-model="qq" placeholder="请输入内容"></el-input>
						</p> -->
					</div>
					<!-- <div class="_butnBox"> -->
						<!-- <p @click.stop="infoType ? ModifyInfo() : saveModify()">{{infoType ? '修改基本信息' : '保存修改'}}</p> -->
						<!-- <p>修改手机</p>
						<p>修改密码</p> -->
					<!-- </div> -->
				</div>
				<div class="_cont">
					<p class="_label">我的账户</p>
					<div class="_conts">
						<div class="_left">
							<p>当前账户余额（元）</p>
							<p v-if="infoData">{{infoData.balance_alias ? infoData.balance_alias : '0'}}</p>
						</div>

					</div>
					<!-- <div class="_payButn"> -->
					<p class="_payup" @click.stop="jumpTopup()">立即充值</p>
					<!-- </div> -->
				</div>
				<div class="_bot">
					<p class="_label">IP白名单（全局生效）</p>
					<textarea v-if="infoData" v-model="infoData.ip_white" class="_textarea" name="" id="" cols="30" rows="10"></textarea>
					<p class="_payup" @click.stop="getUpdIpWhite()">保存</p>
				</div>
			</template>
    </div>
  </div>
</template>

<script>
import { request } from "../../css/request.js";
import { Apis } from "../../css/Api.js";
export default {
	data(){
		return {
			infoType:true,
			qq:'19820982345',
			wx:'19820982345',
			infoData:null,
			visible:false,
			receiveType:false,
			loading: true
		}
	},
	created(){
		this.getInfoData()
		// this._receiveType()
	},
	methods:{
		_receiveType(){
			// isgetfree
			let access_token = localStorage.getItem('access_token')
			let data = {
				access_token:access_token,
			}
			request({
				method: 'get', 
				url: Apis.isgetfree,
				params:data
			}).then(res => {
				if(res.code == 0){
					if(res.data == "false"){
						this.receiveType = false
					}else if(res.data == 'true'){
						this.receiveType = true
					}
				}else{
					this.$message.error(res.msg);receiveType
				}
			});
		},
		_receive(){
			let access_token = localStorage.getItem('access_token')
			let data = {
				access_token:access_token,
			}
			request({
				method: 'get', 
				url: Apis.getfree,
				params:data
			}).then(res => {
				if(res.code == 0){
					this.$message({
						message: '领取成功',
						showClose: true,
						duration:1500,
						type: 'success',
						onClose:() =>{
							this.getInfoData()
							this._receiveType()
						}
					});
					this.getInfoData()
				}else{
					this.$message.error(res.msg);
				}
			});
		},
		visibles(){
			this.visible = !this.visible
		},
		getUpdIpWhite(){
			let access_token = localStorage.getItem('access_token')
			let data = {
				access_token:access_token,
				ip_white:this.infoData.ip_white
			}
			request({
				method: 'post', 
				url: Apis.updIpWhite,
				params:data
			}).then(res => {
				if(res.code == 0){
					this.$message({
						message: '白名单保存成功',
						showClose: true,
						duration:1500,
						type: 'success'
					});
					this.getInfoData()
				}else{
					this.$message.error(res.msg);
				}
			});
		},
		ModifyInfo(){
			this.infoType = false;
		},
		saveModify(){
			this.infoType = true;
		},
		jumpTopup(){
			this.$router.push({ path: '/topup' })
		},
		getInfoData(){
			let access_token = localStorage.getItem('access_token')
			let data = {
				access_token:access_token
			}
			request({
				method: 'get', 
				url: Apis.readMemberInfo,
				params:data
			}).then(res => {
				if(res.code == 0){
					this.infoData = res.data
					this.$store.commit("setMineData", res.data);
				}else{
					this.$message.error(res.msg);
				}
				this.loading = false
			});
		},
	}

}
</script>

<style lang="less" scoped>
._InfoBox{
	width: 100%;
	._gift{
		width: 100%;
		height: 74px;
		// background: red;
		position: relative;
		._bg{
			position: absolute;
			left: 0;
			top: 0;
			width: 100%;
			height: 72px;
			// opacity: 0;
		}
		._cot{
			position: absolute;
			width: 100%;
			height: 72px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 0 76px 0 70px;
			._left{
				// width: calc(100% - 500px);
				position: relative;
				._popover{
					background-color: #fff;
					margin:50px auto;
					width:580px;
					height:186px;
					// border-radius: 10px;
					position: absolute;
					top: -10px;
					left: 88%;
					z-index: 9999;
					// color: #fff;	
					padding: 15px 20px;
					box-shadow: 0px 6px 19px 0px rgba(0, 0, 0, 0.2);
					._h1{
						font-size: 16px;
						font-weight: bold;
						line-height: 28px;
					}
					span{
						display: inline-block;
						width: 100%;
						text-align: left;
						color: #1E1D1D;
					}
				}
				._popover::before{
					content:" ";
					border-left: 8px solid transparent;
					border-top:0px solid #fff;
					border-right:8px solid transparent;
					border-bottom:10px solid #fff;
					position: absolute;left:10px;top:-10px;
				}
				._giftText{
					font-size: 17px;
					font-weight: bold;
					color: #242323;
					position: relative;
					._p1{
						color: #FF752A;
					}
					._elIcon{
						display: inline-block;
						width: 20px;
						height: 20px;
						background: url("../../assets/_gift_wh.png")no-repeat;
						background-size: 100% 100%;
						// margin-top: 2px;
						position: relative;
						top: 3px;
						left: 5px;
						cursor:pointer;
					}
				}
				._giftText::before{
					content: '';
					display: inline-block;
					width: 19px;
					height: 21px;
					background: url("../../assets/_gift_3.png")no-repeat;
					background-size: 100% 100%;
					position: absolute;
					top: -3px;
					left: -25px;
				}
			}
			._right{
				._btn{
					background: #FF4646;
					width: 116px;
					height: 48px;
					border-radius: 6px;
					color: #fff;
					font-weight: bold;
					font-size: 17px;
					line-height: 48px;
					cursor:pointer;
				}
				._true{
					opacity: 0.5;
				}
			}

		}
	}
	._top{
		width: 100%;
		padding: 18px;
		height: 210px;
		background: #fff;
		position: relative;
		margin-top: 20px;
		._list{
			width: 100%;
			display: flex;
			p{
				width: 33.33%;
				margin-top: 53px;
				span{
					display: inline-block;
					width: 100%;
					text-align: left;
					font-size: 16px;
					color: #7D7D7D;
				}
				span:nth-child(2){
					margin-top: 20px;
					// font-size: ;
					color: #1E1D1D;
				}
			}
		}
		._butnBox{
			// width: 450px;
			display: flex;
			position: absolute;
			right: 20px;
			top: 20px;
			p{
				width: 127px;
				height: 50px;
				border: 1px solid #BBBBBB;
				border-radius: 6px;
				line-height: 50px;
				margin-left: 20px;
				font-size: 18px;
				color: #242323;
				cursor:pointer;
			}
			p:hover{
				background: #1F8EFF;
				color: #fff;
				border: none;
			}
		}
	}
	._cont{
		width: 100%;
		padding: 18px;
		height: 210px;
		margin-top: 27px;
		background: #fff;
		position: relative;
		._conts{
			width: 100%;
			margin-top: 26px;
			margin-left: 22px;
			display: flex;
			._left{
				width: 40%;
				p{
					font-size: 18px;
					color: #1E1D1D;
					text-align: left;
				}
				p:nth-child(2){
					font-size: 48px;
					font-weight: bold;
					color: #D44F8D;
					margin-top: 31px;
				}
			}
			._right{
				width: 40%;
				p{
					font-size: 18px;
					color: #1E1D1D;
					text-align: left;
				}
				p:nth-child(2){
					font-size: 48px;
					font-weight: bold;
					color: #D44F8D;
					margin-top: 31px;
				}
			}
		}
		._payup{
			width: 120px;
			height: 50px;
			background: #1F8EFF;
			color: #fff;
			line-height: 50px;
			font-weight: bold;
			font-size: 18px;
			border-radius: 6px;
			position: absolute;
			right: 20px;
			bottom: 20px;
			cursor:pointer;
		}
	}
	._bot{
		width: 100%;
		padding: 18px;
		height: 312px;
		margin-top: 27px;
		background: #fff;
		position: relative;
		._textarea{
			width: 96%;
			resize: none;
			height: calc(100% - 60px);
			margin-top: 20px;
			border: 1px solid #E3E3E3;
			outline: none;
			padding: 10px;
		}
		._payup{
			width: 120px;
			height: 50px;
			background: #1F8EFF;
			color: #fff;
			line-height: 50px;
			font-weight: bold;
			font-size: 18px;
			border-radius: 6px;
			position: absolute;
			right: 50px;
			bottom: 40px;
			cursor:pointer;
		}
	}
}
._label{
	// width: 140px;
	text-align: left;
	padding-left: 10px;
	position: relative;
	line-height: 30px;
	font-weight: bold;
	font-size: 20px;
	left: 10px;
}
._label::after{
	content: '';
	display: inline-block;
	width: 4px;
	height: 23px;
	background: #51B3FF;
	position: absolute;
	top: 5px;
	left: 0px;
}
</style>